/* eslint-disable no-magic-numbers */
import { customMedia } from '@space-core/styles'

import styled, { css } from 'styled-components'

import { FULL_VIEWPORT, BANNER_HEIGHT_OFFSET_IN_PIXELS } from './constants'

import { Direction } from './enum'

export const Slider = styled.div<{ $showBannerHighlight: boolean }>`
  margin: 0 auto;
  white-space: nowrap;
  touch-action: pan-y;

  ${({ $showBannerHighlight }) =>
    $showBannerHighlight && 'border: solid 0.188rem var(--blue); border-radius:0.5rem;'}

  &:hover {
    ._arrow-slide,
    ._dots-slide {
      display: flex;
    }
  }
`

export const SliderWrapper = styled.div<{
  $currentIndex: number
  $slides: number
  $isPreview: boolean
  $parentWidth: number
}>`
  box-sizing: content-box;
  transition: transform ease-in-out 0.3s;

  ${({ $slides, $isPreview, $currentIndex, $parentWidth }) => customMedia.greaterThan('xxl')`
      ${
        $isPreview &&
        css`
          width: ${$parentWidth * $slides}px;
          transform: translateX(-${$currentIndex * $parentWidth}px);
        `
      }
    `};

  ${({ $slides, $isPreview, $currentIndex, $parentWidth }) =>
    `
    transform: translateX(${
      $isPreview
        ? `-${$currentIndex * $parentWidth}px`
        : `-${$currentIndex * Number(FULL_VIEWPORT)}vw`
    });
    width: ${$isPreview ? `${$parentWidth * $slides}px` : `${Number(FULL_VIEWPORT) * $slides}vw`};
  `}
`

export const SlideContainer = styled.div<{
  $parentWidth: number
  $isMobile: boolean
  $isPreview: boolean
}>`
  max-width: 100%;
  display: flex;

  ${({ $isPreview, $parentWidth }) => customMedia.greaterThan('xxl')`
      ${$isPreview && `width: ${$parentWidth}px`}
    `};

  ${({ $parentWidth, $isMobile, $isPreview }) => {
    const width = $isPreview ? `${$parentWidth}px` : '100vw'
    const computedHeight = $parentWidth / 2.4 - BANNER_HEIGHT_OFFSET_IN_PIXELS
    const height = $isMobile ? '25rem' : `${computedHeight}px`
    const maxHeight = $isMobile ? '25rem' : `${computedHeight}px`

    return css`
      width: ${width};
      height: ${height};
      max-height: ${maxHeight};
    `
  }}
`

export const SlideContent = styled.div<{ $isMobile: boolean }>`
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'inherit')};
  flex: 0 0 100%;
`

export const ArrowWrapper = styled.div<{ $direction: string }>`
  top: 0;
  display: none;
  ${({ $direction }) => ($direction === Direction.RIGHT ? `right: 0` : `left: 0`)};
`

export const BlurGradientFooter = styled.div`
  width: 120%;
  height: 11.25rem;
  z-index: 9;
  bottom: -5.625rem;
  left: -3.125rem;
  filter: blur(2.375rem);

  ${customMedia.lessThan('sm')`
    height: 5.625rem;
    bottom: -2.813rem;
    left: -3.125rem;
    filter: blur(1.25rem);
  `}
`

export const Highlight = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 11;
`
